import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, message, Button } from 'antd'
import BasicForm from '../formV4'
import {
  getExperts,
  sendMembershipEmail,
  sendWelcomeEmail
} from '../../api/team'
import PageLoading from '../UI/status/loading'
import _ from 'lodash'
import { connect } from 'react-redux'

const PartnershipEmailAddress = 'partnerships@apeiron.life'

function getFormData(experts) {
  return [
    {
      type: 'select',
      options: experts.map((expert) => {
        if (expert.email === PartnershipEmailAddress) {
          return {
            label: expert.email,
            value: expert.email
          }
        }
        return {
          label: expert.first_name + ` (${expert.email})`,
          value: expert.email
        }
      }),
      dbField: 'from',
      label: 'from',
      rules: [{ required: true, message: 'This field is required' }]
    },
    {
      type: 'input',
      label: 'subject',
      dbField: 'subject',
      rules: [{ required: true, message: 'This field is required' }]
    },
    {
      type: 'richText',
      extraAttr: {
        toolbarHidden: true
      },
      dbField: 'content',
      rules: [{ required: true, message: 'Please input email content' }]
    }
  ]
}

class WelcomeEmail extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    person: PropTypes.object,
    experts: PropTypes.array
  }

  state = {
    loading: false,
    pageloading: true,
    valueForm: {},
    experts: this.props.experts,
    isMembership: this.props.isMembership || false
  }

  sendEmail = async () => {
    const { onCancel, person, isMembership, onSend } = this.props
    this.setState({ loading: true })
    try {
      const params = await this.refForm.handleSubmit()
      if (isMembership) {
        const { experts } = this.state
        const seller = experts.find((e) => e.email === params.from).first_name
        params.seller_admin = seller
        await sendMembershipEmail(params, person.id)
      } else {
        await sendWelcomeEmail(params, person.id)
      }
      message.success('Success!')
      onCancel()
      this.setState({ loading: false })
      if (isMembership) {
        onSend()
      }
    } catch (err) {
      this.setState({ loading: false })
    }
  }

  getTemplete = (from) => {
    const { person, account } = this.props
    const { experts } = this.state
    const env = process.env.REACT_APP_WORKFLOW
    const signInLink =
      env === 'production'
        ? 'https://app-dlc.apeiron.life/sign-in'
        : 'https://app-staging-dlc.apeiron.life/sign-in'
    const admin = experts.find((e) => e.email === from)
    const dateOfAssessment = _.get(person, 'profile.date_of_assessment') || '-'
    return `<p>Hi ${(person.profile && person.profile.nickname) ||
      person.first_name},</p>
      <p>Welcome to Apeiron! We're pleased you've chosen to embark on your wellness journey with us through Discovery Land's ${
        person.facility.name
      }.</p>
      <p>Your ${_.get(
        person,
        'profile.membership'
      ).toUpperCase()} Healthspan Assessment is scheduled for ${dateOfAssessment}, and we're eager to get started.</p>
      <p>To streamline your experience, we've set up your online account. Please click <a href="${signInLink}" _blank="target" style="text-decoration: underline">here</a> to access your account using the following credentials:</p>
      <p>Username: ${person.email}<br>Password: ${_.upperFirst(
      person.first_name
    )}password</p>
      <p>Upon logging in, you will be prompted to change your password. Next, you will need to fill out a quick pre-assessment medical review and a couple of logistical fields, and sign a liability waiver. These steps should take about five minutes, and once you’ve completed them, a member of our Concierge team will reach out to schedule the other appointments that accompany your in-person assessment (including the assessment review where our team will go over all the results and recommendations).</p>
      <p>Following the waiver, you’ll see some questionnaires about your current lifestyle that will help us to better personalize your assessment experience and tailor our recommendations to your goals and needs. Please complete these before you come in for your assessment.</p>
      <p>If you have any questions or need assistance, feel free to contact us. Otherwise, we look forward to seeing you on ${dateOfAssessment}.</p>
     <p>Warm regards,${
       admin ? `<br>${admin.first_name}` : `<br>${account.user.first_name}`
     }</p>`
  }

  updateValueForm = async (changedValues) => {
    if (!this.refForm) return
    if (changedValues.from) {
      const { valueForm } = this.state
      const template = this.getTemplete(changedValues.from)
      valueForm.content = template
      this.refForm.setFieldValue('content', template)
      this.setState({
        valueForm: _.cloneDeep(valueForm)
      })
    }
  }

  getExperts = async () => {
    const result = await getExperts()
    this.setExperts(result)
  }

  setExperts = (experts) => {
    const { account } = this.props
    let e = [...experts]
    e.push({
      email: PartnershipEmailAddress,
      first_name: account.user.first_name
    })
    this.setState({ experts: e, pageloading: false })
    this.initial()
  }

  initial = (experts) => {
    const template = this.getTemplete(PartnershipEmailAddress)
    this.setState({
      valueForm: {
        content: template,
        subject: 'Welcome to Apeiron!',
        from: PartnershipEmailAddress
      }
    })
  }

  componentDidMount() {
    const { experts } = this.state
    if (experts && experts.length > 0) {
      this.setExperts(experts)
    } else {
      this.getExperts()
    }
  }

  render() {
    const { onCancel, isMembership } = this.props
    const { loading, valueForm, pageloading, experts } = this.state
    return (
      <Modal
        open={true}
        onCancel={onCancel}
        className="phs-modal client-creation"
        width={'-'}
        footer={
          <>
            <Button onClick={onCancel}>CANCEL</Button>
            <Button onClick={this.sendEmail} type="primary" loading={loading}>
              SEND
            </Button>
          </>
        }
      >
        <h1 className="title">
          {isMembership
            ? 'Send Membership Selection Page'
            : 'Send Onboarding Email'}
        </h1>
        {pageloading ? (
          <PageLoading />
        ) : (
          valueForm.content && (
            <BasicForm
              wrappedComponentRef={(inst) => (this.refForm = inst)}
              initialValues={valueForm}
              formData={getFormData(experts)}
              onChange={this.updateValueForm}
            />
          )
        )}
      </Modal>
    )
  }
}

export default connect(({ account }) => ({ account }))(WelcomeEmail)
